var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgInfoIcon = function SvgInfoIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 14,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#242E30",
    d: "M3.467 5.785H.547V13.5h2.92zM3.857 1.929a1.929 1.929 0 1 0-3.857 0 1.929 1.929 0 0 0 3.857 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export default ForwardRef;